export default {
    /**
     * Datos añadidos a data por el mixin:
     * - businessTypesOptions: array con tipos de entidades
     *
     * @return {Object} Data del mixin
     */
    data() {
        return {
            businessTypesOptions: []
        };
    },
    methods: {
        /**
         * Load cna group types
         */
        loadBusinessTypesOptions() {
            const businessTypes = this.$t(`businessTypes`);
            this.businessTypesOptions = Object.entries(businessTypes).map(item => {
                return {
                    key: item[0],
                    name: item[1]
                };
            });
        }
    },

    /**
     * Antes de montar el componente se cargan los tipos de entidades en la variable
     * `this.businessOptions`
     */
    beforeMount() {
        this.loadBusinessTypesOptions();
    }
};
